import { cacheDom } from '../utils/QuerySelectors.js'
import { getInlineCart, updateCart, getCartUpsells, getCart } from '../utils/Cart.js'
const dom = {}
const qs = {
  cartPanel: 'data-cart-panel',
  cartDetails: 'data-cart-details',
  cartClose: 'data-cart-close',
  upsellWrapper: 'data-upsells',
  sezzleWidget: 'data-inline-cart-sezzle',
  originSezzle: 'data-inline-sezzle-widget',
}
const qsAll = {
  triggers: 'data-cart-trigger',
  removeItems: 'data-item-remove',
  cartCounts: 'data-cart-count',
}

const closePanel = (e) => {
  dom.cartPanel.classList.remove('z-50', 'opacity-100')
  dom.cartPanel.classList.add('z-[-1]', 'opacity-0')
}
const initInlineCart = (responseText) => {
  dom.cartDetails.innerHTML = responseText
  dom.cartPanel.querySelector(`[${qs.cartClose}]`).addEventListener('click', closePanel)
  dom.cartPanel.querySelectorAll(`[${qsAll.removeItems}]`).forEach((removeItem) => {
    removeItem.addEventListener('click', () => {
      const updates = {}
      updates[removeItem.dataset.key] = 0
      updateCart(null, updates, true, location.href.includes('/cart'))
    })
  })
  const upsellWrapper = dom.cartPanel.querySelector(`[${qs.upsellWrapper}]`)
  if (upsellWrapper) {
    getCartUpsells((upsells) => {
      console.log('upsells', upsells)
      upsells.forEach((upsell, index) => {
        if (index < 4) {
          upsellWrapper.innerHTML += `<div class="h-full" product-tile variant='${JSON.stringify(
            upsell.variant,
          ).replaceAll("'", '’')}' product='${JSON.stringify(upsell.product).replaceAll("'", '’')}' open="true"></div>`
        }
      })
      window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
    })
  }
  dom.cartPanel.classList.remove('z-[-1]', 'opacity-0')
  dom.cartPanel.classList.add('z-50', 'opacity-100')

  getCart((cartData) => {
    inlineCartRenderSezzle.alterPrice(`${cartData.cart.total_price / 100.0}`)
    setTimeout(() => {
      if (dom.cartPanel.querySelector(`[${qs.sezzleWidget}]`)) {
        const clone = dom.originSezzle.cloneNode(true)
        dom.cartPanel.querySelector(`[${qs.sezzleWidget}]`).appendChild(clone)
        dom.cartPanel.querySelector(`[${qs.sezzleWidget}] button`).addEventListener('click', () => {
          const c = new Event('click')
          if (dom.originSezzle.querySelector('button')) {
            dom.originSezzle.querySelector('button').dispatchEvent(c)
          }
        })
      }
    }, 300)
  }, false)
}
window.initInlineCart = initInlineCart

const updateCartCount = (itemCount) => {
  dom.cartCounts.forEach((cartCount) => {
    cartCount.innerHTML = `
      ${itemCount < 100 ? '<span aria-hidden="true" class="font-bold">' + itemCount + '</span>' : ''}
      <span class="hidden">${itemCount} ${itemCount > 1 ? 'items' : 'item'}</span>
    `
  })
}
window.updateCartCount = updateCartCount

const initCartTrigger = (trigger) => {
  trigger.addEventListener('click', () => {
    getInlineCart((responseText) => {
      initInlineCart(responseText)
    })
  })
}

export const setupInlineCart = () => {
  cacheDom(dom, qs, qsAll)
  dom.triggers.forEach((trigger) => initCartTrigger(trigger))
  if (dom.cartPanel) {
    dom.cartPanel.addEventListener('click', closePanel)
    dom.cartDetails.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  }
}
